var _filter, _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-2qgrgz",
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: ":r1i:-filter",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 20.8643,
    width: 20,
    x: 2,
    y: 2
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2978_44160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2978_44160",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r1i:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3,
    x2: 20.7881,
    y1: 4.50437,
    y2: 20.7206
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#:r1i:-filter)",
    className: "Ui-outlineFilter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m18.17 3c-.6895 0-1.3789.26263-1.9034.78716-.4866.48655-3.9432 4.23242-7.23663 8.00674l3.04043 3.0404c3.7743-3.2934 7.5208-6.75002 8.0073-7.23657 1.0491-1.04906 1.0491-2.75871-.0027-3.81057-.526-.52453-1.2156-.78716-1.905-.78716zm.1098 8.9236c-.5676.001-1.1329.1803-1.6051.5344.7369.4528 1.2288 1.2681 1.2288 2.1934 0 .9197-.4866 1.7269-1.215 2.1797.9718.7111 2.2672.6833 3.1953 0-.7284-.4528-1.2151-1.26-1.2151-2.1797 0-.9253.492-1.7406 1.2288-2.1934-.4805-.3582-1.0501-.5355-1.6177-.5344zm-9.62061.2949c-1.32188 1.516-2.59343 3.021-3.61996 4.2978.04216.0338.08157.07.1181.1066l2.08409 2.0841c.03656.0393.07337.0787.10711.1181 1.27688-1.0266 2.78137-2.2976 4.29727-3.6194zm7.57941.6416c-.4275.4894-.6663 1.1194-.6663 1.7803 0 .6666.2447 1.3019.6778 1.7941.6469-.3319 1.0909-1.0068 1.0909-1.7831 0-.7818-.4499-1.4622-1.1024-1.7913zm4.0978 0c-.6553.3291-1.1052 1.0067-1.1052 1.7913 0 .7763.4441 1.4512 1.091 1.7831.4331-.495.6778-1.1275.6778-1.7941 0-.6609-.2389-1.2909-.6636-1.7803zm-16.30405 3.8683c-.26719 0-.53433.097-.72839.2911-.4034.4034-.40715 1.0529 0 1.4601l2.08134 2.0808c.40657.4066 1.0556.4039 1.45952 0 .39938-.4022.39938-1.0546 0-1.4568l-2.08409-2.0841c-.19406-.1941-.4612-.2911-.72838-.2911z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.17 3c-.6895 0-1.3789.26263-1.9034.78716-.4866.48655-3.9432 4.23242-7.23663 8.00674l3.04043 3.0404c3.7743-3.2934 7.5208-6.75002 8.0073-7.23657 1.0491-1.04906 1.0491-2.75871-.0027-3.81057-.526-.52453-1.2156-.78716-1.905-.78716zm.1098 8.9236c-.5676.001-1.1329.1803-1.6051.5344.7369.4528 1.2288 1.2681 1.2288 2.1934 0 .9197-.4866 1.7269-1.215 2.1797.9718.7111 2.2672.6833 3.1953 0-.7284-.4528-1.2151-1.26-1.2151-2.1797 0-.9253.492-1.7406 1.2288-2.1934-.4805-.3582-1.0501-.5355-1.6177-.5344zm-9.62061.2949c-1.32188 1.516-2.59343 3.021-3.61996 4.2978.04216.0338.08157.07.1181.1066l2.08409 2.0841c.03656.0393.07337.0787.10711.1181 1.27688-1.0266 2.78137-2.2976 4.29727-3.6194zm7.57941.6416c-.4275.4894-.6663 1.1194-.6663 1.7803 0 .6666.2447 1.3019.6778 1.7941.6469-.3319 1.0909-1.0068 1.0909-1.7831 0-.7818-.4499-1.4622-1.1024-1.7913zm4.0978 0c-.6553.3291-1.1052 1.0067-1.1052 1.7913 0 .7763.4441 1.4512 1.091 1.7831.4331-.495.6778-1.1275.6778-1.7941 0-.6609-.2389-1.2909-.6636-1.7803zm-16.30405 3.8683c-.26719 0-.53433.097-.72839.2911-.4034.4034-.40715 1.0529 0 1.4601l2.08134 2.0808c.40657.4066 1.0556.4039 1.45952 0 .39938-.4022.39938-1.0546 0-1.4568l-2.08409-2.0841c-.19406-.1941-.4612-.2911-.72838-.2911z",
    fill: "url(#:r1i:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-outline",
    d: "m7.24142 18.707h-.00001zm0 0 .00796.0086c.03393.0365.06785.073.09915.1095 1.17059-.9411 2.53246-2.0877 3.91907-3.2905l.0246.0246.3536-.3535-.3286-.3769c-.0086.0075-.0172.015-.0258.0225l-2.27786-2.2784c.0075-.0086.015-.0172.0225-.0258l-.37685-.3286-.35359.3536.02466.0246c-1.07201 1.2358-2.09961 2.4522-2.97664 3.5308-.00064-.0005-.00128-.001-.00193-.0015l-.31246.3903c.00132.0011.00263.0021.00394.0032.04068.0329.07878.068.11416.1034zm1.41181-7.2418c-.06849.0785-.10826.1727-.11975.2694-.09663.0251-.18442.0788-.25114.1553-1.32472 1.5192-2.60084 3.0295-3.63279 4.3132-.02995.0372-.05413.0782-.07213.1216-.17679-.0649-.36262-.0963-.54507-.0963-.38435 0-.78373.1393-1.08194.4376h-.00002c-.59746.5975-.60358 1.5635 0 2.1671l.00006.0001 2.08128 2.0807c.60268.6027 1.56832.5984 2.16666 0l.00121-.0012c.43716-.4402.55204-1.0815.34466-1.6274.04131-.0176.0809-.0411.11756-.0705 1.28361-1.032 2.79338-2.3076 4.31258-3.6323.0767-.0668.1304-.1548.1555-.2517.0966-.0115.1908-.0513.2692-.1197 3.775-3.2939 7.5326-6.76023 8.0322-7.25982 1.2446-1.24464 1.244-3.27087-.0028-4.51767l-.0005-.00047c-.6234-.62184-1.4418-.93314-2.258-.93314s-1.6346.31127-2.257.93361c-.4995.49957-3.9658 4.25662-7.25977 8.03159zm7.72147.5928c-.1004.0753-.1676.1846-.1909.3051-.1214.0134-.2371.0711-.3218.1681-.507.5804-.7897 1.3272-.7897 2.1092 0 .7897.29 1.5421.8025 2.1244.0854.0971.2019.1544.3239.167.0247.1202.0932.2287.1945.3028 1.1513.8424 2.6862.8096 3.787-.0009.1007-.0741.1687-.1822.1934-.3019.1224-.0126.2393-.0703.3248-.1681.5111-.584.8016-1.3328.8016-2.1233 0-.7819-.2828-1.5281-.7859-2.108-.0855-.0984-.2028-.1567-.3257-.1696-.0235-.1209-.0911-.2304-.192-.3056-.5698-.4248-1.2453-.6349-1.9175-.6336-.672.0012-1.3429.2135-1.9042.6344z",
    stroke: "#5800e9",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.7d4faa0be5152451e94ac6f97983e1b6.svg";
export { ForwardRef as ReactComponent };